module.exports = __webpack_public_path__ + "static/media/school_high.31df89e0.svg";